/**
 * Created by zoechodosh on 3/7/17.
 */
import fetch from 'isomorphic-fetch';
import {
  getEntitiesRequest,
  getEntitiesResponse,
  editEntityRequest,
} from '../EntityActions';

export const editEvent = event => (dispatch) => {
  dispatch(editEntityRequest(event));
};

export function getRsvpPageEvents() {
  return (dispatch) => {
    dispatch(getEntitiesRequest());
    return fetch('/web-api/v2/cms/page/rsvp',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(getEntitiesResponse(json, 'events')));
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/website/entities/RsvpActions.js
 **/